

export interface AloBase {
    id:number
    libelle:string
    selected?:boolean
}

export const getDefaultAloBase = ():AloBase => {
    return {
        id:0,
        libelle:'',
        selected:false
    }
}